import { AsyncPipe } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { combineLatest, map, Observable, Subscription, switchMap } from 'rxjs';

import { CanvasCommunicationService, FeatureFlagsConfigService, FieldIncrementMode, NumericFieldComponent } from '@olympus/ngx-shared';
import { UtSettingsModel } from 'ut-business/models';

@Component({
  selector: 'app-ribbon-quick-actions',
  templateUrl: './ribbon-quick-actions.component.html',
  imports: [NumericFieldComponent, AsyncPipe],
})
export class RibbonQuickActionsComponent implements OnInit, OnDestroy {
  public readonly FIELD_INCREMENT_MODE: FieldIncrementMode = FieldIncrementMode.ON_DELAY;
  private readonly _subscription: Subscription = new Subscription();

  public utSettingsModel: UtSettingsModel | undefined;
  public isSetup$: Observable<boolean> = this._communicationService.context.inspectionModeController.isSetup$;
  public isInspection$: Observable<boolean> = this._communicationService.context.inspectionModeController.isInspection$;
  public isAnalysis$: Observable<boolean> = this._communicationService.context.inspectionModeController.isAnalysis$;
  public featureFlagAnalysis: boolean;
  public isInspectionOrAnalysis$: Observable<boolean> = combineLatest([this.isInspection$, this.isAnalysis$],
    (isInspection, isAnalysis) => isInspection || isAnalysis);

  public isInspectionOrSetup$: Observable<boolean> = combineLatest([this.isInspection$, this.isSetup$],
    (isInspection, isSetup) => isInspection || isSetup);

  constructor(
    private readonly _communicationService: CanvasCommunicationService,
    private readonly _featureFlagsConfigService: FeatureFlagsConfigService,
  ) {
    this.featureFlagAnalysis = this._featureFlagsConfigService.getFeature('analysis');
  }

  public ngOnInit(): void {
    this._subscription.add(
      this._communicationService.context.activeGroupId$.pipe(
        map(() => this._communicationService.context.activeGroupModel),
        switchMap(activeGroupModel => activeGroupModel.utSettingsModel.utSettingsModel$),
      ).subscribe((model: UtSettingsModel) => {
        this.utSettingsModel = model;
      }),
    );
  }

  public ngOnDestroy(): void {
    this._subscription.unsubscribe();
  }
}
